 
  <section *ngIf="loading">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
    </mat-progress-bar>
  </section>

  <section *ngIf="processing">
    <h2>Processing...</h2>
    <mat-progress-bar mode="indeterminate" color="primary" aria-label="Processing...">
    </mat-progress-bar>
  </section>
  
  <section *ngIf="!loading && !processing">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <h2 class="noMarginHeader">
            <mat-icon>add</mat-icon> Link Treatment to Sample
        </h2>
      </div>
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
        <button type="submit" (click)="approveLink()" mat-raised-button color="primary" title="Link Treatment" [disabled]="selectedId <= 0">Link Treatment</button>
        &nbsp;&nbsp;
        <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic" title="Close">Close</button>
      </div>
    </div>
  </section>
    
  <mat-dialog-content [hidden]="loading || processing">

    <div fxLayout="row wrap" fxLayoutGap="8px grid" fxFlex="100" fxFlex.lt-sm="100">
      <div fxFlex="100" fxFlex.lt-sm="100">
          <mat-card>
            <mat-table [dataSource]="dataSourceTreatmentPlans" class="mat-elevation-z8" *ngIf="voucherId != null && voucherId.length > 0">
              <mat-header-row *matHeaderRowDef="displayedColumnsTreatmentPlans"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsTreatmentPlans;"></mat-row>
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef >Select</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <input type="radio" id="treatmentId" name="treatmentId"
                  value="{{result.treatmentId}}" (click)="onChangeSelectedTreatment(result.treatmentId)" />
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="treatmentId">
                <mat-header-cell *matHeaderCellDef >Treatment Id</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.treatmentId}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="statusOfInstall">
                <mat-header-cell *matHeaderCellDef >Status Of Install</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.statusOfInstall}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="installedBy">
                <mat-header-cell *matHeaderCellDef >Installed By</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.installedBy}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="treatmentInstallCompletionDate">
                <mat-header-cell *matHeaderCellDef >Install Completion Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.treatmentInstallCompletionDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="latestFilterChangeDate">
                <mat-header-cell *matHeaderCellDef >Latest Filter Change Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.latestFilterChangeDate}}
                </mat-cell>
              </ng-container>
            </mat-table>

            {{treatmentId}}
            <span [hidden]="treatmentId <= 0">test</span>
            <mat-table [dataSource]="dataSourceSamples" class="mat-elevation-z8" [hidden]="treatmentId <= 0">
              <mat-header-row *matHeaderRowDef="displayedColumnsSamples"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsSamples;"></mat-row>
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef >Select</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <input type="radio" id="sampleId" name="sampleId"
                  value="{{result.sampleId}}" (click)="onChangeSelectedSample(result.sampleId)" />
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="sampleId">
                <mat-header-cell *matHeaderCellDef >Sample Id</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.sampleId}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef >Sample Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.createDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="collectionDate">
                <mat-header-cell *matHeaderCellDef >Analysis Date</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.collectionDate}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="retOrNot">
                <mat-header-cell *matHeaderCellDef >Type</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  {{result.retOrNot}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="isSampleReTest">
                <mat-header-cell *matHeaderCellDef >Is Sample ReTest?</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <span *ngIf="result.isSampleReTest">Yes</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="postTreatment">
                <mat-header-cell *matHeaderCellDef >Post Treatment?</mat-header-cell>
                <mat-cell *matCellDef="let result">
                  <span *ngIf="result.postTreatment">Yes</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="treatmentId">
                <mat-header-cell *matHeaderCellDef >Linked Treatment id</mat-header-cell>
                <mat-cell *matCellDef="let result">                  
                  <span *ngIf="result.treatmentId > 0">{{result.treatmentId}}</span>
                </mat-cell>
              </ng-container>
            </mat-table>
          </mat-card> 
      </div> 
    </div>
 
    
      
  </mat-dialog-content>
 